module.exports = __webpack_public_path__ + "static/img/14000139.1a4c687c.png";